import React from 'react';

import { createClassName } from 'utils/createClassName';

import './tooltipStyles.scss';

type Props = {
  visible: boolean;
};

export const TooltipComponent: React.FC<Props> = (props) => {
  const { children, visible } = props;

  const className = createClassName('tooltip')({ visible });

  return <div className={className}>{children}</div>;
};
